// src/components/LakersNavBar/LakersNavbar.js
import React from 'react';
import './LakersNavBar.css';
import { Link } from 'react-router-dom';

const Navbar = () => {

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className="navbar navbar-expand-md navbar-dark bg-dark">
      <div className="container-fluid">
        {/* Navbar Header */}
        <div className="navbar-header d-flex align-items-center">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Logo and Title */}
          <Link className="brand-lakers" to="/">
            <img
              src="/picz/lakersOT/lakerslogo.png"
              alt="Lakers logo"
              className="lakers-icon"
            />
          </Link>
        </div>

        {/* Collapsible menu */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto text-start">
            {/* Navigation Links */}
            <li className="nav-item">
              <a
                className="nav-link"
                onClick={() => scrollToSection('LakersSubscribe')}
                style={{ cursor: 'pointer' }}
              >
                Subscribe
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                onClick={() => scrollToSection('LakersHighlights')}
                style={{ cursor: 'pointer' }}
              >
                Lakers News
              </a>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link nav-link-with-arrow"
                to="/contact" // Use Link for routing
                rel="noreferrer" // This can be omitted here since we are using Link
              >
                Contact
              </Link>
            </li>

            {/* Account Button */}
            <li className="nav-item">
              <a href="#" className="btn-account">Account</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
